"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
require("jquery");
const history_1 = require("history");
class Store {
    constructor() {
        this.skip = 0;
        this.take = 20;
        this.loading = false;
        this.error = false;
    }
    Search(reset = false, skipWindowStateUpdate = false) {
        this.loading = true;
        this.error = false;
        this.skip = reset === true ? 0 : this.skip;
        $.ajax({
            type: "GET",
            url: "/api/SearchApi/Query",
            data: {
                "q": this.query,
                "take": this.take,
                "skip": this.skip
            },
            success: (data) => {
                this.results = data;
                this.previousQuery = this.query;
                this.loading = false;
                if (!skipWindowStateUpdate) {
                    this.UpdateWindowState();
                }
            },
            error: () => {
                this.loading = false;
                this.error = true;
            }
        });
    }
    ChangePage(page) {
        this.skip = (page - 1) * this.take;
        this.Search();
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }
    UpdateWindowState() {
        var object = {
            query: this.query,
            skip: this.skip
        };
        var history = (0, history_1.createBrowserHistory)();
        history.push(window.location.pathname + "?" + $.param(object), object);
        //window.history.pushState(object, null, window.location.pathname + "?" + $.param(object));
    }
}
__decorate([
    mobx_1.observable
], Store.prototype, "query", void 0);
__decorate([
    mobx_1.observable
], Store.prototype, "previousQuery", void 0);
__decorate([
    mobx_1.observable
], Store.prototype, "results", void 0);
__decorate([
    mobx_1.observable
], Store.prototype, "skip", void 0);
__decorate([
    mobx_1.observable
], Store.prototype, "take", void 0);
__decorate([
    mobx_1.observable
], Store.prototype, "loading", void 0);
__decorate([
    mobx_1.observable
], Store.prototype, "error", void 0);
__decorate([
    mobx_1.action.bound
], Store.prototype, "Search", null);
__decorate([
    mobx_1.action.bound
], Store.prototype, "ChangePage", null);
__decorate([
    mobx_1.action.bound
], Store.prototype, "UpdateWindowState", null);
const store = new Store();
exports.default = store;
